var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';
import ConditionalRender from '@baifendian/adhere-ui-conditionalrender';
import Auto from './Auto';
import Fixed from './Fixed';
import FlexLayout from './FlexLayout';
import { selectorPrefix } from './FlexLayout';
/**
 * HorizontalFlexLayout
 * @constructor
 * @param props
 */
var HorizontalFlexLayout = /*#__PURE__*/memo(function (props) {
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    _b = props.style,
    style = _b === void 0 ? {} : _b,
    _c = props.topClassName,
    topClassName = _c === void 0 ? '' : _c,
    _d = props.topStyle,
    topStyle = _d === void 0 ? {} : _d,
    _e = props.rightClassName,
    rightClassName = _e === void 0 ? '' : _e,
    _f = props.rightStyle,
    rightStyle = _f === void 0 ? {} : _f,
    _g = props.bottomClassName,
    bottomClassName = _g === void 0 ? '' : _g,
    _h = props.bottomStyle,
    bottomStyle = _h === void 0 ? {} : _h,
    _j = props.leftClassName,
    leftClassName = _j === void 0 ? '' : _j,
    _k = props.leftStyle,
    leftStyle = _k === void 0 ? {} : _k,
    _l = props.mainClassName,
    mainClassName = _l === void 0 ? '' : _l,
    _m = props.mainStyle,
    mainStyle = _m === void 0 ? {} : _m,
    _o = props.mainAutoWrapClassName,
    mainAutoWrapClassName = _o === void 0 ? '' : _o,
    _p = props.mainAutoStyle,
    mainAutoStyle = _p === void 0 ? {} : _p,
    _q = props.mainWrapClassName,
    mainWrapClassName = _q === void 0 ? '' : _q,
    _r = props.mainWrapStyle,
    mainWrapStyle = _r === void 0 ? {} : _r,
    renderTop = props.renderTop,
    renderRight = props.renderRight,
    renderBottom = props.renderBottom,
    renderLeft = props.renderLeft,
    renderMain = props.renderMain,
    _s = props.topProps,
    topProps = _s === void 0 ? {} : _s,
    _t = props.rightProps,
    rightProps = _t === void 0 ? {} : _t,
    _u = props.bottomProps,
    bottomProps = _u === void 0 ? {} : _u,
    _v = props.leftProps,
    leftProps = _v === void 0 ? {} : _v,
    _w = props.mainProps,
    mainProps = _w === void 0 ? {} : _w,
    _x = props.mainAutoWrapProps,
    mainAutoWrapProps = _x === void 0 ? {} : _x,
    children = props.children,
    attrs = __rest(props, ["className", "style", "topClassName", "topStyle", "rightClassName", "rightStyle", "bottomClassName", "bottomStyle", "leftClassName", "leftStyle", "mainClassName", "mainStyle", "mainAutoWrapClassName", "mainAutoStyle", "mainWrapClassName", "mainWrapStyle", "renderTop", "renderRight", "renderBottom", "renderLeft", "renderMain", "topProps", "rightProps", "bottomProps", "leftProps", "mainProps", "mainAutoWrapProps", "children"]);
  var leftElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(ConditionalRender, {
      conditional: !!renderLeft
    }, function () {
      return /*#__PURE__*/React.createElement(Fixed, __assign({
        className: leftClassName !== null && leftClassName !== void 0 ? leftClassName : '',
        style: leftStyle !== null && leftStyle !== void 0 ? leftStyle : {},
        fit: true
      }, leftProps !== null && leftProps !== void 0 ? leftProps : {}), renderLeft);
    });
  }, [renderLeft, leftClassName, leftStyle, leftProps]);
  var mainElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(ConditionalRender, {
      conditional: !!renderMain
    }, function () {
      return /*#__PURE__*/React.createElement(Auto, __assign({
        className: classNames(mainAutoWrapClassName),
        style: mainAutoStyle !== null && mainAutoStyle !== void 0 ? mainAutoStyle : {},
        fit: true,
        autoFixed: true
      }, mainAutoWrapProps !== null && mainAutoWrapProps !== void 0 ? mainAutoWrapProps : {}), /*#__PURE__*/React.createElement(FlexLayout, {
        direction: "vertical",
        className: classNames(mainWrapClassName),
        style: mainWrapStyle !== null && mainWrapStyle !== void 0 ? mainWrapStyle : {}
      }, /*#__PURE__*/React.createElement(ConditionalRender, {
        conditional: !!renderTop
      }, function () {
        return /*#__PURE__*/React.createElement(Fixed, __assign({
          className: classNames(topClassName),
          style: topStyle !== null && topStyle !== void 0 ? topStyle : {},
          fit: true
        }, topProps !== null && topProps !== void 0 ? topProps : {}), renderTop);
      }), /*#__PURE__*/React.createElement(Auto, __assign({
        autoFixed: true,
        fit: true,
        className: classNames(mainClassName),
        style: mainStyle !== null && mainStyle !== void 0 ? mainStyle : {}
      }, mainProps !== null && mainProps !== void 0 ? mainProps : {}), renderMain), /*#__PURE__*/React.createElement(ConditionalRender, {
        conditional: !!renderBottom
      }, function () {
        return /*#__PURE__*/React.createElement(Fixed, __assign({
          className: classNames(bottomClassName),
          style: bottomStyle !== null && bottomStyle !== void 0 ? bottomStyle : {},
          fit: true
        }, bottomProps !== null && bottomProps !== void 0 ? bottomProps : {}), renderBottom);
      })));
    });
  }, [renderMain, mainAutoWrapClassName, mainAutoStyle, mainAutoWrapProps, mainWrapClassName, mainWrapStyle, renderTop, topClassName, topStyle, topProps, mainClassName, mainStyle, mainProps, renderBottom, bottomClassName, bottomStyle, bottomProps]);
  var rightElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(ConditionalRender, {
      conditional: !!renderRight
    }, function () {
      return /*#__PURE__*/React.createElement(Fixed, __assign({
        className: classNames(rightClassName),
        style: rightStyle !== null && rightStyle !== void 0 ? rightStyle : {},
        fit: true
      }, rightProps !== null && rightProps !== void 0 ? rightProps : {}), renderRight);
    });
  }, [renderRight, rightClassName, rightStyle, rightProps]);
  return /*#__PURE__*/React.createElement(FlexLayout, __assign({}, attrs, {
    className: classNames("".concat(selectorPrefix, "-horizontal-flex-layout"), className),
    style: style !== null && style !== void 0 ? style : {},
    direction: "horizontal"
  }), leftElement, mainElement, rightElement);
});
HorizontalFlexLayout.displayName = 'HorizontalFlexLayout';
export default HorizontalFlexLayout;